import React from 'react'

export default function InfoImg() {
  return (
    <div>
      <svg width="24" height="24" viewBox="0 0 25 26" fill="none" xmlns="http://www.w3.org/2000/svg">
<ellipse cx="12.5" cy="12.9991" rx="12.5" ry="12.5089" fill="#1D56C6"/>
<path d="M12.5057 20.917C16.8806 20.917 20.4271 17.3705 20.4271 12.9956C20.4271 8.62075 16.8806 5.07422 12.5057 5.07422C8.13082 5.07422 4.58429 8.62075 4.58429 12.9956C4.58429 17.3705 8.13082 20.917 12.5057 20.917Z" stroke="white" strokeLinecap="round" strokeLinejoin="round"/>
<path d="M12.5057 16.1647V12.9961" stroke="white" strokeLinecap="round" strokeLinejoin="round"/>
<path d="M12.5057 9.82715H12.5133" stroke="white" strokeLinecap="round" strokeLinejoin="round"/>
</svg>
    </div>
  )
}
